import { FC } from 'react';
import { Flex } from 'antd';
import {
  ErrorMessage,
  SLabelTitle,
  ModalDialog,
  SInput,
  STextArea,
} from '../../';
import { IProps } from './type';
import styles from '../../../assets/styles/index.module.scss';

const OrganizationModal: FC<IProps> = (props) => {
  const { getFieldProps, errors, touched } = props.formik;

  return (
    <ModalDialog
      title={props.title}
      subTitle={props.subTitle}
      open={props.open}
      handleOk={props.handleSubmit}
      handleCancel={props.handleCancel}
    >
      <Flex gap="middle" vertical>
        <Flex vertical gap="small">
          <SLabelTitle>Şirket Bilgileri</SLabelTitle>
          <Flex justify="space-between" gap="small">
            <Flex vertical gap="small" className={styles.widthHalf}>
              <SInput placeholder="Şirket Adı" {...getFieldProps('name')} />
              {touched.name && errors.name && (
                <ErrorMessage>{errors.name}</ErrorMessage>
              )}
            </Flex>
            <Flex vertical gap="small" className={styles.widthHalf}>
              <SInput placeholder="Şirket Ünvanı" {...getFieldProps('title')} />
              {touched.title && errors.title && (
                <ErrorMessage>{errors.title}</ErrorMessage>
              )}
            </Flex>
          </Flex>
        </Flex>
        <Flex vertical gap="small">
          <STextArea placeholder="Adres" {...getFieldProps('address')} />
          {touched.address && errors.address && (
            <ErrorMessage>{errors.address}</ErrorMessage>
          )}
        </Flex>
        <Flex justify="space-between" gap="small">
          <Flex vertical gap="small" className={styles.widthHalf}>
            <SInput
              placeholder="Vergi Numarası"
              {...getFieldProps('tax_number')}
            />
            {touched.tax_number && errors.tax_number && (
              <ErrorMessage>{errors.tax_number}</ErrorMessage>
            )}
          </Flex>
          <Flex vertical gap="small" className={styles.widthHalf}>
            <SInput
              placeholder="Vergi Dairesi"
              {...getFieldProps('tax_office')}
            />
            {touched.tax_office && errors.tax_office && (
              <ErrorMessage>{errors.tax_office}</ErrorMessage>
            )}
          </Flex>
        </Flex>
      </Flex>
    </ModalDialog>
  );
};

export default OrganizationModal;
